<template>
    <zen-one
        :showuserinfo="false"
        title="Laporan: Notis"
        :crumbs="crumbs"
    >
        <z-page title="Laporan Penguatkuasaan">
            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="primary" id="cetak" class="mr3" @click="cetak2A()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak Laporan 2A
                    </w-button>
                    <w-button bg-color="primary" id="cetak" class="mr3" @click="cetak6A()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak Laporan 6A
                    </w-button>
                    <w-button bg-color="primary" id="cetak" class="mr3" @click="cetak8A()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak Laporan 8A
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>
<script>
import ZResource from "@/Modules/z-resource";
export default {
    extends: ZResource,
    data(){
        return{
            apiBaseUrl: process.env.MIX_API_BASE_URL,
             crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
                {
                    label: "Laporan Penguatkuasaan",
                    route: "/penguatkuasaan/laporan",
                },
            ],
        }
    },
    methods:{
        cetak2A() {
            var url1 = `${this.apiBaseUrl}/cukai/laporan2A`;
            window.open(url1, "_blank");
        },
        cetak6A() {
            var url1 = `${this.apiBaseUrl}/cukai/laporan6A`;
            window.open(url1, "_blank");
        },
        cetak8A() {
            var url1 = `${this.apiBaseUrl}/cukai/laporan8A`;
            window.open(url1, "_blank");
        },
    }
}
</script>
<style></style>
